/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_TitleInputs */

const en_simple_oto_faq_title = /** @type {(inputs: Simple_Oto_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common questions`)
};

const id_simple_oto_faq_title = /** @type {(inputs: Simple_Oto_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertanyaan yang sering muncul`)
};

/**
* | output |
* | --- |
* | "Common questions" |
*
* @param {Simple_Oto_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_title = /** @type {((inputs?: Simple_Oto_Faq_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_title(inputs)
	return en_simple_oto_faq_title(inputs)
});